export const PLAN_INFO = [
    {
        key: "essential",
        name: "GGH Essential",
        tagline: "For hotels beginning their sustainability journey.",
        features: [
            "GGH membership",
            "Basic sustainability assessment",
            "Sustainability score",
            "Basic improvement recommendations",
            "Hotel profile",
            "Member resources",
        ],
        popular: false,
    },
    {
        key: "professional",
        name: "GGH Professional",
        tagline: "For hotels that want to actively improve and measure sustainability.",
        features: [
            "Everything in Essential",
            "Detailed assessment",
            "Food-waste assessment",
            "Sustainability dashboard",
            "Staff training",
            "Detailed improvement plan",
            "Annual progress review",
        ],
        popular: true,
    },
    {
        key: "leader",
        name: "GGH Leader",
        tagline: "For hotels seeking advanced sustainability management.",
        features: [
            "Everything in Professional",
            "Advanced reporting",
            "Benchmarking when available",
            "Priority support",
            "Additional consulting benefits",
            "Advanced hotel profile",
            "Enhanced progress tracking",
        ],
        popular: false,
    },
];

export const HOTEL_TYPES = [
    "Independent hotel",
    "Boutique hotel",
    "Resort",
    "Hotel group / chain",
    "Eco-lodge",
    "Bed & breakfast / guesthouse",
    "Other hospitality business",
];

export const ASSESSMENT_AREAS = [
    { key: "food", label: "Food & Food Waste", desc: "How food is purchased, prepared, served and recovered." },
    { key: "energy", label: "Energy", desc: "Electricity, heating, cooling and efficiency practices." },
    { key: "water", label: "Water", desc: "Water use, fixtures, laundry and monitoring." },
    { key: "waste", label: "Waste Management", desc: "Separation, recycling and landfill reduction." },
    { key: "purchasing", label: "Sustainable Purchasing", desc: "Suppliers, materials and procurement choices." },
    { key: "employees", label: "People & Training", desc: "Staff participation, learning and wellbeing." },
    { key: "community", label: "Community", desc: "Local sourcing, partnerships and local value." },
    { key: "management", label: "Sustainability Management", desc: "Goals, accountability and continuous improvement." },
];

export const formatPrice = (cents) =>
    cents ? `$${(cents / 100).toLocaleString("en-US")} / year` : "";
